module.exports = __webpack_public_path__ + "2620c8c2/img/ion_calendar-number.3ac5bd07.svg";